import JWTAuth from './jwt';

export const AuhMethods = {
  jwtAuth: JWTAuth
};
